export const enum FontFamily {
    Roboto = "Roboto",
    VWTextCarUI = "VWTextCarUI",
}
